// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12151"][{"3471":0}[chunkId]] || "1.12157") + "/" + chunkId + ".js";
};